import { 
    SET_VOLUME,
    SET_AUDIO_TO_PLAY,
    INCREMENT_AUDIO_COUNT,
    INCREMENT_STOP_AUDIO_COUNT,
    SET_MENU_STATE,
    SET_OVERLAY_STATE,
    SET_SECTION_AS_ANIMATED,
    SET_USER_INTERACTED,
    TRIGGER_GTM_PUSH,
    SET_NAV_METHOD_FOR_GTM
} from "../constants/action-types";

export const setVolume = (volumeIsOn) => ({ type: SET_VOLUME, volumeIsOn });
export const setAudioToPlay = (audioKey) => ({ type: SET_AUDIO_TO_PLAY, payload: audioKey });
export const incrementAudioPlayCount = () => ({ type: INCREMENT_AUDIO_COUNT });
export const stopAudio = () => ({ type: INCREMENT_STOP_AUDIO_COUNT });

export const setMenuState = (menuIsOpen) => ({ type: SET_MENU_STATE, menuIsOpen });

export const setOverlayState = (overlayIsActive) => ({ type: SET_OVERLAY_STATE, overlayIsActive });

export const setSectionAsAnimated = (sectionId) => ({type: SET_SECTION_AS_ANIMATED, sectionId});

export const setUserInteracted = () => ({type: SET_USER_INTERACTED})

export const triggerGTMPush = (eventData) => ({type: TRIGGER_GTM_PUSH, eventData})

export const setNavMethodForGTM = (method) => ({type: SET_NAV_METHOD_FOR_GTM, method})
